import { useEffect, useState } from "react";
import { getUsers } from "../../services/AuthService";

export function GroupForm({ initialGroup = null, onSubmit, onCancel }) {
  const [groupName, setGroupName] = useState(initialGroup ? initialGroup.name : "");
  const [usersList, setUsersList] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState(
    initialGroup ? new Set(initialGroup.userIds || []) : new Set()
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getUsers()
      .then((users) => setUsersList(users))
      .catch(() => setUsersList([]))
      .finally(() => setLoading(false));
  }, []);

  const toggleUser = (userId) => {
    setSelectedUserIds((prev) => {
      const next = new Set(prev);
      next.has(userId) ? next.delete(userId) : next.add(userId);
      return next;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!groupName.trim()) return;
    const groupData = {
      name: groupName.trim(),
      members: selectedUserIds.size,
      userIds: Array.from(selectedUserIds),
      id: initialGroup ? initialGroup.id : undefined,
    };
    onSubmit(groupData);
  };

  if (loading) return <p className="text-center mt-8 text-gray-600">Loading users...</p>;

  return (
    <div className="max-w-xl mx-auto py-8 px-4">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        {initialGroup ? "Edit Group" : "Create New Group"}
      </h2>
      <form onSubmit={handleSubmit} className="bg-white shadow rounded-lg p-6">
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Group Name</label>
          <input
            type="text"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Add Users to Group</label>
          <div className="max-h-48 overflow-y-auto border border-gray-300 rounded-md p-2">
            {usersList.length === 0 ? (
              <p className="text-gray-500 text-sm italic">No users available</p>
            ) : (
              usersList.map((user) => (
                <label
                  key={user.id}
                  className="flex items-center mb-2 cursor-pointer select-none"
                >
                  <input
                    type="checkbox"
                    className="form-checkbox h-5 w-5 text-indigo-600"
                    checked={selectedUserIds.has(user.id)}
                    onChange={() => toggleUser(user.id)}
                  />
                  <span className="ml-2 text-gray-700">
                    {user.firstName} {user.lastName}
                  </span>
                </label>
              ))
            )}
          </div>
        </div>

        <div className="mb-4 text-sm text-gray-600">Selected members: {selectedUserIds.size}</div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
          >
            {initialGroup ? "Update" : "Create"}
          </button>
        </div>
      </form>
    </div>
  );
}
